<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">


    <sidebar></sidebar>
    <!-- Jobs -->
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw)">
      <div class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-between w-100 col-12 flex-nowrap">
              <h2 style="font-size: 1.2vw !important; text-align: right">شناسایی نیازها بر اساس خبرگی</h2>
              <button style="transform: translateX(5vw)" class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>

            </div>

            <div class="table-responsive" style="overflow-y: scroll; height: 40vw;">
              <table class="table table-striped">
                <thead>
                <tr class="sticky-header">
                  <th style="width: 1vw;">ردیف</th>
                  <th>دسته  </th>
                  <th>گروه  </th>
                  <th>ذی نفع</th>
                  <th style="width: 10vw;">نیازهای اساسی</th>
                   <th style="width: 10vw;">نیازهای عملکردی</th>
                   <th style="width: 10vw;">نیازهای انگیزشی</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in items">
                  <td scope="row">{{index+1}}</td>
                  <td>{{item.parents_names && item.parents_names.category}}</td>
                  <td>{{item.parents_names && item.parents_names.group}}</td>
                  <td>{{item.title}}</td>
                  <td>
                    <button @click.prevent="NeedsModal(1,item.id)" class="btn btn-submit-1 btn-primary w-100">تکمیل / بروزرسانی</button>
                  </td>
                  <td>
                    <button @click.prevent="NeedsModal(2,item.id)" class="btn btn-submit-1 btn-primary w-100">تکمیل / بروزرسانی</button>
                  </td>
                  <td>
                    <button @click.prevent="NeedsModal(3,item.id)" class="btn btn-submit-1 btn-primary w-100">تکمیل / بروزرسانی</button>
                  </td>

                </tr>

                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 55%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="Delete">تایید</button>
      </div>
    </div>
  </div>

<!--  <button @click.prevent="save(beneficiary_id)" class="btn btn-primary btn-submit-1" type="submit" >ثبت</button>
  <Reset style="width: 1.5vw;height: 1.5vw;" class="mx-2" @click.prevent="reset()" />-->
  <div dir="rtl" class="modal__error" v-if="NeedsModalStatus" style="width: 50vw;">
    <div>
      <p>{{needs_title}}</p>
      <p @click="NeedsModalStatus=!NeedsModalStatus">❌</p>
    </div>
    <hr>
    <div class="row mb-3">
      <div class="d-flex flex-column col-5">
        <label>عنوان {{needs_title}}</label>
        <textarea v-model="title" class="form-control" id="" cols="30" rows="10"></textarea>
      </div>
      <div class="d-flex flex-column col-4">
        <label class="form-label">نوع نیاز</label>
        <select v-model="type" class="form-select" name="" required>
          <option value="چگونگی">چگونگی</option>
          <option value="چه میزانی">چه میزانی</option>

        </select>
      </div>
      <div class="d-flex flex-column col-2 ">
        <button v-if="!status" @click.prevent="save" class="btn btn-submit-1 btn-primary" style="margin-top: 1.7vw;">ذخیره</button>
       <div   v-if="status" class="d-flex">
         <button @click.prevent="save" class="btn btn-submit-1 btn-primary" style="margin-top: 1.7vw;">ویرایش</button>
         <Reset  style="width: 1.5vw;height: 1.5vw; margin-top: 1.7vw;" class="mx-2" @click.prevent="reset()" />
       </div>
      </div>
    </div>
    <hr>
    <div class="w-100 mt-3 d-flex justify-content-start" style="height: 24vw; overflow-y: scroll">
      <table v-if="needs_items.length" class="table table-striped">
        <thead>
        <tr class="sticky-header">
          <th style="width: 1vw;">ردیف</th>
          <th>عنوان {{ needs_title.replace('های', '') }} </th>
          <th>نوع نیاز  </th>
          <th style="width: 6vw;"></th>
        </tr>
        </thead>
        <tbody>
        <tr class="bg-white" v-for="(item,index) in needs_items">
          <td>{{index+1}}</td>
          <td>{{item.title}}</td>
          <td>{{item.type}}</td>
          <td >
            <a @click.prevent="edit(item)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
            <a @click.prevent="DoDelete(item.id)" style="margin-right: 0.5vw;" href="#"><img  class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>
          </td>
        </tr>

        </tbody>
      </table>
      <center v-else>موردی یافت نشد!</center>

    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar/Sidebar";
import Splash from "@/components/Splash/Splash";
import Reset from "@/components/Icons/Reset.vue";
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  name: "beneficiary_id",
  components: {Reset, Splash, Sidebar},
  data(){
    return{
      items: [],
      needs_items: [],
      id_item: '',
      title: '',
      beneficiary_id: '',
      type: '',
      status: false,
      deleteModal: false,
      NeedsModalStatus: false,
      needs_title: '',
      mode: 1,
    }
  },
  methods:{
    NeedsModal(type,id){
      this.NeedsTitles(type)
      this.NeedsModalStatus = true
      this.beneficiary_id = parseInt(id)
      this.mode = type
      this.all_need(this.beneficiary_id, this.mode)

    },
    NeedsTitles(type){
      const num = parseInt(type)
      if (num===1){
        this.needs_title = 'نیازهای اساسی'
      }else  if (num===2){
        this.needs_title = 'نیازهای عملکردی'
      }else  if (num===3){
        this.needs_title = 'نیازهای انگیزشی'
      }
    },
    DoDelete(id){
      if (!id){
        toast.error('شما مجاز به انجام عملیات نیستید!')
        return false;
      }
      this.reset()
      this.id_item = id
      this.deleteModal = true
    },
    Delete(){
      if (typeof this.id_item !== "number"){
        this.deleteModal = false
        toast.error('خطای ناشناخته!')
        return;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/BeneficiaryExpertise/destroy/${this.id_item}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
            }
            if (response.message){
              toast.success(response.message)

              this.all_need(this.beneficiary_id, this.mode)

              this.deleteModal = false
            }

          })
          .catch();
    },
    all(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/BeneficiaryExpertise`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const all = response.all
            this.items = [...all]

          })
          .catch();
    },
    edit(item){
      const obj = item
      if (typeof obj === 'object'){
        this.status = true
        this.title = obj.title
        this.type = obj.type
        this.id_item = obj.id




      }

    },
    save(){
      if (!this.title){
        toast.error('عنوان اجباری است!')
        return false;
      } else if (!this.type){
        toast.error('نوع نیاز  اجباری است!')
        return false;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('title', this.title)
      formdata.append('type', this.type)
      formdata.append('mode', this.mode)
      formdata.append('beneficiary_id', this.beneficiary_id)
      if (this.id_item){
        formdata.append('id', this.id_item)
      }

       var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/BeneficiaryExpertise/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
            }
            if (response.message){
              toast.success(response.message)
              this.reset()
              this.all_need(this.beneficiary_id, this.mode)
            }

          })
          .catch();
    },
    all_need(id,type){
      this.needs_items.length=0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/BeneficiaryExpertise/all/${id}/${type}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.needs_items = response.all

            }
          })
          .catch();
    },
    reset(){
      this.status = false
      this.title = ''
      this.type = ''

    },
  },
  mounted() {
    this.all()
  }
}
</script>

<style scoped>
.row{
  padding: .5vw;
}
</style>